import * as Yup from 'yup';

import { termsAndConditionValidation } from '../components/forms/FormTermsAndConditionsCheckbox';

export const validationSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  firstName: Yup.string().nullable().required('Please enter your first name.'),
  lastName: Yup.string().nullable().required('Please enter your last name.'),
  terms: termsAndConditionValidation
});
